export default "__VITE_ASSET__Diee4hE5__"